import { Component, OnInit } from '@angular/core';
import { Events, AlertController, ModalController } from '@ionic/angular';
import { Router, RouterEvent, } from '@angular/router';
import { GlobalService } from '../global.service';
import { AngularFireDatabase } from '@angular/fire/database';

@Component({
  selector: 'app-character',
  templateUrl: './character.page.html',
  styleUrls: ['./character.page.scss'],
})
export class CharacterPage implements OnInit {

    character = GlobalService.CHARACTER;
    user = GlobalService.FirebaseUser;
    selectedPath: string = '';
    pages: {
        title: string;
        url: string;
        icon: string;
    }[] = [
            {
                title: 'Character Sheet',
                url: '/character',
                icon:"document"
            },
            {
                title: '1. Personal',
                url: '/character/personal',
                icon: ""
            },
            {
                title: '2. Stats',
                url: '/character/stats',
                icon: ""
            },
            {
                title: '3. Skills',
                url: '/character/skills',
                icon: ""
            },
            {
                title: '4. Gear',
                url: '/character/gear',
                icon: ""
            },
            {
                title: '5. Lifepath',
                url: '/character/lifepath',
                icon: ""
            }
        ];
    constructor(private db: AngularFireDatabase, public events: Events, private router: Router, private alertController: AlertController, private globalService: GlobalService) {
        this.events.subscribe("character:changed", (e) => {

            this.character = GlobalService.CHARACTER;
            this.user = GlobalService.FirebaseUser;
        });
        this.router.events.subscribe((event: RouterEvent) => {
            this.selectedPath = event.url==null?"":event.url;
            //console.log(event.url);

        });
    }
    ngOnInit() {
        if (GlobalService.CURRENT == null) {
            this.router.navigateByUrl("home");
        }
    }

    getInfo(p) {


            switch (p.url) {
                case "/character/roles":
                    return this.character.role;
                    break;
                case "/character/personal":
                    return this.character.name + ", " + this.character.role;
                    break;
                case "/character/stats":
                    return this.character.statPoints + " / " + this.character.statPointsAllocation + " points";
                    break;
                case "/character/skills":
                    return this.character.skillPoints + " / " + this.character.skillPointsAllocation + " points";
                    break;
            }

            return "";
    }
    save() {
        var uid = GlobalService.FirebaseUser.uid;
        if (this.character.UID == null) {
            var uuid = GlobalService.UUID();
            this.character.UID = uuid;

        }

        const itemRef = this.db.object("characters/" + GlobalService.FirebaseUser.uid + "/" + this.character.UID);
        itemRef.set(GlobalService.CHARACTER);
        this.globalService.toast("Character Saved");
    }

}
